export const SCENE_CONSTANTS = {
  SHADOWS: {
    MAP_SIZE: 4096,
    CAMERA_NEAR: -100,
    CAMERA_FAR: 200,
    CAMERA_LEFT: -400,
    CAMERA_RIGHT: 400,
    CAMERA_TOP: 400,
    CAMERA_BOTTOM: -400
  },

  COLORS: {
    SCENE_BACKGROUND: 0x151B23,
    DEFAULT_CASE: 0x111111,
    DEFAULT_BOARD: 0x222222,
    DEFAULT_KEYCAP: 0x020202,
    DEFAULT_LEGEND: 0xdddddd,
    SWITCH_HOUSING: 0xffffff,
    SWITCH_BASE: 0x000000,
    SWITCH_STEM: 0x990000
  },

  MATERIALS: {
    KEYCAP_ROUGHNESS: 0.8,
    KEYCAP_METALNESS: 0.0,
    KEYCAP_BUMP_SCALE: 0.002,
    CASE_ROUGHNESS: 0.6,
    CASE_METALNESS: 0.2,
    BOARD_ROUGHNESS: 0.8,
    BOARD_METALNESS: 0.1,
    GROUND_ROUGHNESS: 0.95,
    GROUND_METALNESS: 0.0,
    SWITCH_HOUSING_OPACITY: 0.4,
    SWITCH_HOUSING_ROUGHNESS: 0.1,
    SWITCH_BASE_ROUGHNESS: 0.5,
    SWITCH_BASE_METALNESS: 0.8,
    SWITCH_STEM_ROUGHNESS: 0.3,
    SWITCH_STEM_METALNESS: 0.5
  },

  POSITIONS: {
    SWITCH_Y: 2,
    SWITCH_GROUP_Y: 0.4,
    KEYCAP_Y: 3.5,
    KEYCAP_GROUP_Y: 3.5,
    BOARD_Y: -0.8,
    KEYBOARD_GROUP_Y: -0.5,
    GROUND_Y: -6,
    CAMERA_INITIAL_X: 20.586,
    CAMERA_INITIAL_Y: 93.627,
    CAMERA_INITIAL_Z: 89.375,
    CAMERA_TARGET_X: 4.525,
    CAMERA_TARGET_Y: -7.532,
    CAMERA_TARGET_Z: 10.823,
    SPLIT_KEYBOARD_SPACING: 50
  },

  LIGHTING: {
    DIRECTIONAL_INTENSITY: 1,
    FILL_INTENSITY: 0.8,
    AMBIENT_INTENSITY: 1.5,
    DIRECTIONAL_X: 10,
    DIRECTIONAL_Y: 20,
    DIRECTIONAL_Z: 10,
    FILL_X: -10,
    FILL_Y: 8,
    FILL_Z: -10
  },

  GEOMETRY: {
    GROUND_SIZE: 100000
  },

  TEXTURE: {
    CANVAS_SIZE: 128,
    FONT_SIZE: 28,
    FONT_FAMILY: 'Arial',
    FONT_WEIGHT: 'bold'
  }
}

export const FILE_PATHS = {
  SWITCH_MODEL: '/models/switch.glb',
  KEYCAP_MODEL: '/models/cfx.stl'
}

export const REQUIRED_FIELDS = [
  'yamlPath',
  'casePath',
  'boardPath',
  'keyMap',
  'rows',
  'columns'
]

export const VALIDATION_ERRORS = {
  MISSING_REQUIRED_FIELD: (field) => `Required field missing: ${field}`,
  INVALID_TYPE: (field, expected, actual) => `Invalid type for ${field}: expected ${expected}, got ${actual}`,
  INVALID_RANGE: (field, min, max, actual) => `Invalid range for ${field}: expected ${min}-${max}, got ${actual}`,
  FILE_NOT_FOUND: (path) => `File not found: ${path}`,
  NETWORK_ERROR: (path, status) => `Network error loading ${path}: ${status}`,
  MODEL_LOAD_ERROR: (path, error) => `Failed to load model ${path}: ${error}`,
  YAML_PARSE_ERROR: (path, error) => `Failed to parse YAML ${path}: ${error}`
}
